import React, { useState, useEffect, useRef, useContext } from 'react';
import { ImCancelCircle } from "react-icons/im";
import InvoiceForm from './InvoiceForm';
import InvoiceApi from '../api/InvoiceApi';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import InvoiceDetails from './InvoiceDetails';
import Pagination from '../component/paginations/pagination';
import SettingApi from '../api/SettingApi';
import axios from 'axios';
import { FiSearch } from "react-icons/fi";
import { SettingsContext } from '../Context/SettingContext';

const InvoiceList = ({ refresh }) => {
    const [state, setState] = useState([]);
    const [totalInvoice, setTotalInvoice] = useState(0);
    const [showDetails, setShowDetails] = useState(false);
    const [itemDetails, setItemDetails] = useState(false);
    const taskDetailsRef = useRef(null);
    const modalRef = useRef(null);
    const [editInvoiceId, setEditInvoiceId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage, setPostsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const {settings} = useContext(SettingsContext);
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(false);
    const validLocale = ['en-US', 'bn-BD'].includes(settings?.region) ? settings.region : 'en-US';
    
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            getInvoice();
        }, 300); 
        return () => clearTimeout(delayDebounceFn);
    }, [searchQuery, refresh]);
    
    // useEffect(() => {
    //     getInvoice();
    // }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target) && showDetails) {
                setShowDetails(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showDetails]);
    
    // add invoices api call data & add search System
    const getInvoice = async () => {
        setLoading(true);
        try {
            const res = await InvoiceApi.index({ search: searchQuery });
            if (Array.isArray(res)) {
                
                const activeInvoices = res.filter(invoice => !invoice.deleted_at);
                setState(activeInvoices);
            } else {
                console.error("API response is not an array:", res);
            }
        } catch (error) {
            console.error("Error fetching invoices:", error);
        } finally {
            setLoading(false);
        }
    };


    const deleteInvoice = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this invoice?");
        if (confirmDelete) {
            try {
                const result = await InvoiceApi.delete(id); 
                if (result.success) { 
                    alert("Invoice deleted successfully!"); 
                    getInvoice();
                } else {
                    console.error("Delete failed:", result.message || 'Unknown error');
                }
            } catch (error) {
                console.error("Error deleting invoice:", error);
            }
        }
    };
    
    const toggleDetails = (invoiceId = null, showInvoiceDetails = false) => {
        setShowDetails(!showDetails);
        setItemDetails(showInvoiceDetails);
        setEditInvoiceId(invoiceId);
    };
    
    const lastPostIndex = currentPage * postsPerPage;
    const firstPostIndex = lastPostIndex - postsPerPage;
    const currentPosts = state.slice(firstPostIndex, lastPostIndex);
    const handlePostsPerPageChange = (e) => {
        const newPostsPerPage = parseInt(e.target.value);
        setPostsPerPage(newPostsPerPage);
        setCurrentPage(1);
    };
    
    return (
        <div>
            <div className="mx-auto">
                <div className="flex justify-between items-center bg-white px-6 py-4 border-b">
                    <div className="text-lg text-gray-500">
                        <h1>All Invoices</h1>
                    </div>
                    <div className='flex gap-x-4'>
                        <div className="relative">
                            <input
                            type="text"
                            placeholder="Search items..."
                            className="appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded py-2.5 px-4 ml-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <div className="absolute right-2 top-[25%]">
                            <FiSearch size={20} />
                            </div>
                        </div>
                        <div>
                            <button onClick={() => toggleDetails()} ref={taskDetailsRef} className="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow ">
                                Add
                            </button>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="overflow-x-auto shadow-md sm:rounded-lg">
                        <div className="inline-block min-w-full align-middle">
                            <div className="overflow-hidden ">
                                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                                    <thead className="bg-gray-100 dark:bg-gray-700">
                                        <tr>
                                            <th scope="col" className="p-4">
                                                <div className="flex items-center">
                                                    <input id="checkbox-all" type="checkbox" className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                                    <label htmlFor="checkbox-all" className="sr-only">checkbox</label>
                                                </div>
                                            </th>
                                            <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                                Invoice No
                                            </th>
                                            <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                                Order No
                                            </th>
                                            <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                                BILL OR INV
                                            </th>
                                            <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                                Customer
                                            </th>
                                            <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                                Status
                                            </th>
                                            <th scope="col" className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                                Invoice Date
                                            </th>
                                            <th scope="col" className="p-4">
                                                <span className="sr-only">Edit</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                                    {currentPosts?.map((invoice, index) => (
                                            <tr className="hover:bg-gray-100 dark:hover:bg-gray-700" key={index}>
                                                <td className="p-4 w-4">
                                                    <div className="flex items-center">
                                                        <input id={`checkbox-table-${index}`} type="checkbox" className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                                        <label htmlFor={`checkbox-table-${index}`} className="sr-only">checkbox</label>
                                                    </div>
                                                </td>
                                                <td className=" px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                    <a className='hover:text-blue-500 cursor-pointer' onClick={() => toggleDetails(invoice.id, true)}>{invoice?.invoice_no}</a>
                                                </td>
                                                <td className=" px-6 text-sm font-medium text-gray-500 whitespace-nowrap dark:text-white">{invoice.order_no}</td>
                                                {/* {invoice.invoice_no === ''} */}
                                                <td className=' px-6 text-sm font-medium text-gray-500 uppercase whitespace-nowrap dark:text-white'>{invoice.type}</td>
                                                <td className=" px-6 text-sm font-medium text-gray-500 whitespace-nowrap dark:text-white">{invoice.contact_name}</td>
                                                <td className=" px-6 text-sm font-medium text-gray-500 whitespace-nowrap dark:text-white">
                                                    {invoice.status === 'Draft' ?
                                                        <span className="inline-flex items-center gap-x-1.5 py-1.5 px-3 rounded-full text-xs font-medium bg-blue-600 text-white dark:bg-blue-500">{invoice.status}</span>
                                                        : <span className="inline-flex items-center gap-x-1.5 py-1.5 px-3 rounded-full text-xs font-medium bg-teal-500 text-white">{invoice.status}</span>
                                                    }
                                                </td>
                                                <td className=" px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white"> {new Intl.DateTimeFormat(validLocale).format(new Date(invoice?.issued_at))}</td>
                                                <td className=" p-3 text-sm font-medium float-right whitespace-nowrap flex items-center my-auto">
                                                   
                                                    {
                                                        invoice?.invoice_no === '' ? <a 
                                                        title='Edit'
                                                        href={`http://wordpress.local/wp-admin/admin.php?page=wc-orders&action=edit&id=${invoice?.id}`}
                                                        className="text-blue-600 dark:text-blue-500 hover:underline text-2xl ">
                                                        <FaEdit />
                                                        </a>
                                                        :
                                                        <button 
                                                        title='Edit'
                                                        onClick={() => toggleDetails(invoice.id)} 
                                                        ref={taskDetailsRef} 
                                                        className="text-blue-600 dark:text-blue-500 hover:underline text-2xl ">
                                                        <FaEdit />
                                                        </button>
                                                    }

                                                    {
                                                        invoice?.invoice_no === '' ? <a 
                                                        title='Delete'
                                                        href={`http://wordpress.local/wp-admin/admin.php?page=wc-orders&action=edit&id=${invoice?.id}`}
                                                        className="ml-2 text-blue-600 dark:text-blue-500 hover:underline text-2xl ">
                                                       <MdDelete />
                                                        </a>
                                                        :
                                                        <button title='Delete' onClick={() => deleteInvoice(invoice.id)} className="ml-2 text-blue-600 dark:text-blue-500 hover:underline text-2xl"><MdDelete /></button>
                                                    }

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {state.length > 0 &&
                        <div className="flex justify-end items-center mt-4 gap-4">
                            <div className="flex items-center border border-gray-300 rounded-lg px-4 py-1 bg-white shadow-sm">
                                <p className="mr-2 text-gray-700">Per Page</p>
                                <select
                                    className="appearance-none pl-2 pr-5 py-1 text-gray-700 focus:outline-none focus:border-indigo-500"
                                    value={postsPerPage}
                                    onChange={handlePostsPerPageChange}
                                >
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={30}>30</option>
                                    <option value={50}>50</option>
                                </select>
                            </div>

                            <Pagination
                                totalPosts={state.length}
                                // totalPosts={totalInvoice}
                                postsPerPage={postsPerPage}
                                setCurrentPage={setCurrentPage}
                                currentPage={currentPage}
                            />
                        </div>
                    }
                </div>
                
              {showDetails && (
                    <div className="fixed z-10 shadow-xl top-8 md:top-8 right-0 print:text-xl w-full max-w-[1000px] h-full bg-white transition-transform duration-300 overflow-y-auto {{ isOpen ? 'transform translate-x-0' : 'transform translate-x-full' }}" ref={taskDetailsRef}>
                        <div className='flex justify-between p-3'>
                            <a className="mt-2 !ml-2 text-2xl text-gray-400 print:hidden cursor-pointer" onClick={toggleDetails}><ImCancelCircle /></a>
                        </div>
                        <div className=''>
                            {itemDetails ? (
                                <InvoiceDetails invoiceData={state.find(invoice => invoice.id === editInvoiceId)} onSubmits={getInvoice} toogle={toggleDetails} />
                            ) : (
                                <InvoiceForm invoiceId={editInvoiceId} onSubmits={getInvoice} toogle={toggleDetails} />
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default InvoiceList;
